import styled, { css } from 'styled-components';
import { riseIn } from 'src/apps/Path/pathCelebrationStyles';

export const Root = styled.div(
  ({ theme }) => css`
    align-items: flex-start;
    background: linear-gradient(
      180deg,
      ${theme.co.primary98} 0%,
      ${theme.co.primary99} 50%,
      ${theme.co.neutral99} 100%
    );
    color: ${theme.co.neutral20};
    display: flex;
    justify-content: center;
    font-size: ${theme.sz.s3};
    min-height: 100dvh;
    min-width: 100vw;
    width: 100%;
    overflow-y: auto;
    padding: ${theme.sz.s6} ${theme.sz.s5} ${theme.sz.s10};
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s5};
    margin: auto 0;
    text-align: center;
  `,
);

export const RiseIn = styled.div(
  () => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: ${riseIn} 0.4s ease-out 0.35s both;
  `,
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    padding-top: ${theme.sz.s2};
    animation: ${riseIn} 0.4s ease-out 0.5s both;
  `,
);

export const SettingsIconWrapper = styled.button(
  ({ theme }) => css`
    position: fixed;
    bottom: ${theme.sz.s12};
    left: ${theme.sz.s12};
    padding: 0;
    font-size: ${theme.sz.s10};
    height: ${theme.sz.s12};
    width: ${theme.sz.s12};
    cursor: pointer;
    display: flex;
    align-items: end;
    justify-content: space-around;
    border-radius: ${theme.bo.round};
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral98};
    background: ${theme.co.neutral99};
    color: ${theme.co.secondary0};
    box-shadow: 0 3.84px 0 ${theme.co.neutral95};

    &:hover {
      background: ${theme.co.neutral98};
      color: ${theme.co.secondary60};
    }

    &:active {
      background: ${theme.co.neutral95};
      color: ${theme.co.secondary50};
    }

    @media (max-width: ${theme.sz.ml}) {
      display: none;
    }
  `,
);
